import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"kv\"><div class=\"caption\"><h1>公正轉型</h1></div></div><section class=\"sect1\"><div class=\"ctx\"><p>20 多年前台泥在和平水泥工業區打造出全世界唯一港電廠循環經濟園區，現在台泥積極希望將此地轉型成為東部第一個低碳綠能環保園區，朝向資源循環、低碳建材、綠色能源等新發展項目。</p><p>其中，和平電力在朝向淨零轉型過程中也思考可能對既有的經濟、員工及周邊社區產生衝擊，因此如何將包容性與正當性納入公司轉型策略規劃，積極創造、提供氣候減緩調適與轉型需求的工作機會，並透過培力計畫支持受衝擊之利害關係人共同轉型。</p><div class=\"imgContainer1-1\"></div><div class=\"sectTit\">2022 和平來電互動體驗運動會</div><p>住在花蓮和平的居民多數知道自己的部落位於水泥工業區，卻不知道這裡其實也是台灣電力的重要據點，這裏有供應全台灣近 4% 電力的和平電廠，隨著國家能源轉型的政策方向，火力電廠未來也將面對除役，當地部落許多福利項目均來自電廠回饋金，甚至每兩個月各家戶電表均有三～四千元的電費補助，如何攜手周邊社區提升減碳認知、共同瞭望一個更美好的未來是和平電力極為重視的課題。</p><p>和平電力依循台泥企業團的發展策略，攜手同集團的台泥綠能團隊，規劃於和平開展全球第一個MW 級的海洋溫差發電基地，因此提前展開社區溝通，於 2022 年 12 月和平村一年一度的村校運動會同場舉辦了「和平來電」活動，邀請和平村親子共同以闖關體驗，認識和平 20 年來的重要供電角色以及未來可能轉向綠能發展。</p><p>闖關活動中我們設置了電力故鄉、和平低碳環保綠能園區、光風地海再生能源、EV 生活與電池儲能、海洋溫差發電、台泥電機人才培訓專班五個體驗關卡。這裡面有過去 20 年和平青年投入電廠的光榮歷史，也有自 2020 年台泥在和平陸續設置的大型太陽能戶外發電暨藝術裝置以及結合儲能的充電站。</p></div></section>", 2)
const _hoisted_3 = { class: "sect2" }
const _hoisted_4 = { class: "ctx" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<section class=\"sect3\"><div class=\"ctx\"><p>和平村是花蓮秀林鄉第一個設有象徵電動化時代充電設施的部落，小朋友們對駛入村莊的各式電動車如數家珍，闖關活動中透過觸摸、聆聽來了解電動車不再使用傳統汽油也看不到引擎，而是靠著 8,000 顆鋰電池產生動力，透過試乘讓部落的大人小孩體驗未來生活轉型可能的樣貌。</p><p>和平電力同仁也設計了科學教具，讓親子透過操作注入冷熱水形成溫差進而產生電力、轉動風扇，並進一步想像，未來和平地區是否可能透過低溫海水與和平電廠溫排水交互運用產生電力。</p><p>活動中也邀請台泥和平廠和花蓮四維高中合作的「電機技術人才產學合作專班」在學生，來分享自己就讀專班學習到的技術專業與考取證照計畫。台泥電機技術人才專班於 2022 年 9 月開辦，優先錄取和平地區國中畢業生，並不定期安排台泥儲能、綠能電池團隊主管到校分享，希望協助和平村在面對在地企業低碳轉型時，部落年輕世代也具備綠色產業所需技能與投入相關工作的機會。</p><br><div class=\"left\"><div class=\"sectTit\">和平減碳生活親子存摺</div><p>台泥企業團 2023 年 3 月起推動「和平減碳生活親子存摺」，第一階段先與部落的教育中心「和平國小」合作，以親子為組合，學校、社區、住家三個場域實踐減碳，透過老師引導學童在校園午餐完食來減少廚餘並落實分類回收，下課後鼓勵親子定期到台泥 DAKA 園區內的「GEMMA 智慧回收機」回收寶特瓶、手搖杯、鋁罐及電池，返家後由家長引導改變生活習慣、節能減碳。</p><p>參與的親子組可依每項減碳行動包括台電電費單上的減少用電度數所達成的減碳量獲得「碳幣」，紀錄於存摺中，累計之碳幣在學期末由台泥以獲得環境部碳標籤或減碳標籤之商品與親子「交易」他們的減碳努力。碳幣，形成一種鼓勵機制，獎勵品的選定亦希望帶動親子認識並支持願意揭露碳排以及投入減碳的企業品牌。</p></div><div class=\"right\"><div class=\"imgContainer3-1\"></div><div class=\"imgContainer3-2\"></div></div><div class=\"clear\"></div></div></section>", 1)
const _hoisted_6 = { class: "sect4" }
const _hoisted_7 = { class: "ctx" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "sectTit" }, "落實減碳的方法與成效", -1)
const _hoisted_9 = { class: "reduceCarbonMethod" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "tit" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "stick" }),
  /*#__PURE__*/_createElementVNode("div", { class: "tri" })
], -1)
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "sect5" }
const _hoisted_15 = { class: "ctx" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "sectTit" }, "減碳小達人", -1)
const _hoisted_17 = { class: "reduceMaster" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "info" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sign" }, "#")
], -1)
const _hoisted_21 = { class: "right" }
const _hoisted_22 = { class: "tit" }
const _hoisted_23 = { class: "desp" }
const _hoisted_24 = { class: "sect6" }
const _hoisted_25 = { class: "ctx" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("p", null, "2024 年 3 月，和平減碳生活親子存摺計畫進入第二階段，成員包括台泥在和平電廠的在地同仁親子組，並擴大至社區克尼布及吾谷子媽媽教室成員，希望進一步將節電減碳的認知擴散至村莊內。"),
  /*#__PURE__*/_createElementVNode("p", null, "和平減碳生活親子存摺計畫也得到了 NGO 與社會企業的專業支持，荒野保護協會花蓮分會楊和玉主任秘書，特別到和平村傳授節能減碳的正確觀念及日常生活中聰明用電與減碳妙招，包括：")
], -1)
const _hoisted_27 = { class: "right" }
const _hoisted_28 = { class: "reduceCarbonJoin" }
const _hoisted_29 = { class: "desp" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_31 = { class: "saveElec" }
const _hoisted_32 = { class: "icon" }
const _hoisted_33 = ["src"]
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<section class=\"sect7\"><div class=\"ctx\"><div class=\"left\"><div>此外，致力資源循環的社會企業 FNG 所打造的「好歸塑巡迴車」也特別開到花蓮和平駐點，大家把寶特瓶投入巡迴車上的投瓶口，車上內建的機器會立即輾壓成碎片，FNG 團隊也向部落朋友們展示這些寶特瓶碎片後續可以再製成環保袋、野餐墊與拖鞋。好歸塑巡迴車還會即時顯示在民眾投瓶行動後，減少的碳排放量和節省的水資源量，讓每個人都能快速掌握減碳小知識，活動累積減碳量 19,320g。</div><p>另外，和平電廠各式活動舉辦都以 QRcode 掃描報到減少紙張用量、講座場地冷氣設定 26 度搭配電風扇、活動道具都是第N 次再利用、甚至部落媽媽教室成員還共乘和平廠關懷巴士減少運輸碳足跡、自備環保杯裝飲品等，從小事中攜手生活轉型。</p></div><div class=\"right\"><div class=\"imgContainer7-1\"></div></div><div class=\"clear\"></div><div class=\"gallery\"><div class=\"imgContainer7-2\"></div><div class=\"imgContainer7-3\"></div><div class=\"imgContainer7-4\"></div><div class=\"imgContainer7-5\"></div></div></div></section>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("article", null, [
      _hoisted_1,
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_swiper, {
            modules: _ctx.modules,
            "slides-per-view": 1,
            "space-between": 1,
            autoplay: {delay:3000, disableOnInteraction:false},
            speed: 1000,
            loop: true,
            pagination: {clickable:true},
            onSwiper: _ctx.onSwiper,
            onSlideChange: _ctx.onSlideChange,
            class: "swiper"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_swiper_slide, { class: "cover cover1" }),
              _createVNode(_component_swiper_slide, { class: "cover cover2" }),
              _createVNode(_component_swiper_slide, { class: "cover cover3" }),
              _createVNode(_component_swiper_slide, { class: "cover cover4" })
            ]),
            _: 1
          }, 8, ["modules", "onSwiper", "onSlideChange"])
        ])
      ]),
      _hoisted_5,
      _createElementVNode("section", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reduceCarbonMethod, (row, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: idx
              }, [
                _createElementVNode("img", {
                  class: "icon",
                  src: _ctx.setReduceCarbonMethodIcon(row.icon)
                }, null, 8, _hoisted_10),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", null, _toDisplayString(row.tit), 1),
                  _hoisted_12
                ]),
                _createElementVNode("div", {
                  class: "spec",
                  innerHTML: row.spec
                }, null, 8, _hoisted_13)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reduceMaster, (row, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: idx
              }, [
                _createElementVNode("img", {
                  class: "pic",
                  src: _ctx.setReduceCarbonMasterPic(row.pic)
                }, null, 8, _hoisted_18),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, _toDisplayString(row.tit), 1),
                    _createElementVNode("div", _hoisted_23, _toDisplayString(row.desp), 1)
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reduceCarbonJoin, (row, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "item",
                  key: idx
                }, [
                  _createElementVNode("div", {
                    class: "imgContainer6",
                    style: _normalizeStyle(_ctx.setReduceCarbonJoinPic(row.pic))
                  }, null, 4),
                  _createElementVNode("div", _hoisted_29, _toDisplayString(row.desp), 1)
                ]))
              }), 128))
            ])
          ]),
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.saveElec, (row, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: idx
              }, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("img", {
                    src: _ctx.setSaveElecIcon(row.icon)
                  }, null, 8, _hoisted_33)
                ]),
                _createElementVNode("div", {
                  class: "desp",
                  innerHTML: row.desp
                }, null, 8, _hoisted_34)
              ]))
            }), 128))
          ])
        ])
      ]),
      _hoisted_35
    ]),
    _createVNode(_component_Footer)
  ], 64))
}